import { call, put } from "redux-saga/effects";
import { getCareersError, getCareersSuccess } from "../actions/careerActions";
import { routes } from '../../common/api/routes';

export function* getCareersSaga({ payload }) {
    try {
        const response = yield call(routes.getCareers, payload);
        yield put(getCareersSuccess(response));
    } catch (error) {
        yield put(getCareersError(error));
    }
}